type ClockAction = 'clock-in' | 'clock-out' | 'meal-break';
type WorkHourType = 'productive' | 'non-productive';

const WORKDAY_URL =
  'https://sunrun.okta.com/home/workday/0oalen0748QRFU0XC0x7/30';

/** Scheduler Agreement linked from the clock work hours modal footer. */
const SCHEDULER_AGREEMENT_URL =
  'https://docs.google.com/document/d/1I3oJNAEclOSPW_iDN9hxeE_xzQOk6mW8htVJKBNTpck/edit?tab=t.0';

const SCHEDULER_AGREEMENT_FOOTER_LINK_TEXT =
  'Schedulers are expected to not work more than 7 hours per day, 35 hours each week, and no more than 6 Non Productive Hours. Click HERE for the Scheduler Agreement.';

const CA_STREET_SALES_SCHEDULER = 'CA Street Sales Scheduler';

const MEAL_BREAK_DURATION_MINUTES = 30;

const WORKDAY_EVENT_TYPE = {
  CLOCK_IN: 'In',
  CLOCK_OUT: 'Out',
  MEAL_BREAK: 'Meal',
} as const;

const WORKDAY_TIME_ENTRY_DESCRIPTOR = {
  PRODUCTIVE: 'Productive Hours',
  NON_PRODUCTIVE: 'Non-Productive Hours',
} as const;

type WorkdayEventType =
  (typeof WORKDAY_EVENT_TYPE)[keyof typeof WORKDAY_EVENT_TYPE];

const CLOCK_ACTION_EVENT_TYPE: Record<ClockAction, WorkdayEventType> = {
  'clock-in': WORKDAY_EVENT_TYPE.CLOCK_IN,
  'clock-out': WORKDAY_EVENT_TYPE.CLOCK_OUT,
  'meal-break': WORKDAY_EVENT_TYPE.MEAL_BREAK,
};

const CLOCK_ACTION_SUCCESS_MESSAGE: Record<ClockAction, string> = {
  'clock-in': 'Check-in updated successfully',
  'clock-out': 'Check-out updated successfully',
  'meal-break': 'Meal break updated successfully',
};

const CLOCK_RECENT_EVENT_TITLE: Record<WorkdayEventType, string> = {
  [WORKDAY_EVENT_TYPE.CLOCK_IN]: 'You are currently checked-in',
  [WORKDAY_EVENT_TYPE.MEAL_BREAK]: 'You are currently in the meal break',
  [WORKDAY_EVENT_TYPE.CLOCK_OUT]: 'You are currently checked-out',
};

const CLOCK_RECENT_EVENT_MODAL_TYPE: Record<
  WorkdayEventType,
  'success' | 'error' | 'warning'
> = {
  [WORKDAY_EVENT_TYPE.CLOCK_IN]: 'success',
  [WORKDAY_EVENT_TYPE.CLOCK_OUT]: 'error',
  [WORKDAY_EVENT_TYPE.MEAL_BREAK]: 'warning',
};

export {
  type ClockAction,
  type WorkHourType,
  type WorkdayEventType,
  WORKDAY_URL,
  SCHEDULER_AGREEMENT_URL,
  SCHEDULER_AGREEMENT_FOOTER_LINK_TEXT,
  CA_STREET_SALES_SCHEDULER,
  MEAL_BREAK_DURATION_MINUTES,
  WORKDAY_EVENT_TYPE,
  CLOCK_ACTION_EVENT_TYPE,
  CLOCK_ACTION_SUCCESS_MESSAGE,
  CLOCK_RECENT_EVENT_TITLE,
  CLOCK_RECENT_EVENT_MODAL_TYPE,
  WORKDAY_TIME_ENTRY_DESCRIPTOR,
};
